var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-end align-center flex-wrap flex-md-nowrap"},_vm._l((_vm.filters),function(filter){return _c('div',{key:filter.name,staticClass:"w-100 w-lg-200px ma-0 pa-0"},[_c('FilterType',{attrs:{"filter":filter,"updateFunction":_vm.updateDataOfCharts}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }